const env = "production"; //'demo'

export const API_KEY = env === "demo" ? "AIzaSyBDsY25nJ4VZz0iiLLQpPRnjMRnIHkyqg4" : "AIzaSyCLnELKkhtI7078gcDyuIBth5PgUx6Ef4I";
export const CLIENT_ID = env === "demo" ? "blog_betway_com" : "blog_betway_com";
export const TEMPLATE_ID = env === "demo" ? "5yCgy1ZvOkDIggdbpqojei" : "5yCgy1ZvOkDIggdbpqojei";

// Country-specific Betway URLs and parameters
export const BETWAY_URLS = {
	ZA: {
		url: "https://new.betway.co.za/",
		params: {
			btag: "P87216-PR38050-CM112331-TS2078307",
			utm_source: "BetwayScoresGames",
			utm_medium: "Betway_Scores_Predictor_Game",
			utm_campaign: "Betway_Scores",
			utm_content: "Predictor_Football_Scores",
		},
	},
	GH: {
		url: "https://www.betway.com.gh/",
		params: {
			btag: "P87216-PR38046-CM112327-TS2078311",
			utm_source: "BetwayScoresGames",
			utm_medium: "Betway_Scores_GH_Predictor_Game",
			utm_campaign: "Betway_Scores",
			utm_content: "Predictor_Football_Scores",
		},
	},
	ROW: {
		url: "https://betway.com/en/sports",
		params: {
			s: "bw219941",
			a: "DB4607216930611204",
			utm_source: "219941",
			utm_medium: "Affiliate",
			utm_campaign: "DB4607216930611204",
		},
	},
};

// Betway team names mapping - maps team IDs to custom display names
export const BETWAY_TEAM_NAMES = {
	// Premier League teams
	"fb:t:8102": "Manchester Utd",
	"fb:t:8109": "Wolves",
	"fb:t:894": "West Ham",
	"fb:t:889": "Tottenham",
	"fb:t:8103": "Newcastle",
	"fb:t:883": "Leeds",
	"fb:t:8134": "Brighton",

	// La Liga teams

	// Bundesliga teams
	"fb:t:8237": "Stuttgart",
};
